import React from 'react'
import Titre from '../Includes/Misc/Titre'
import FilterReset from '../Includes/Filter/FilterReset'
import AbsencesToolbarContent from './AbsencesToolbarContent'
import {
  useSelector
} from 'react-redux'
import {
  Toolbar
} from '@mui/material'

const AbsencesToolbarDesktop = () => {
  const notification = useSelector(state => state.notifications.notification)
  return (
    <Toolbar>
      <Titre>Absences</Titre>
      {
        (notification === '')
          ? <AbsencesToolbarContent/>
          : <FilterReset notification={true}/>
      }
    </Toolbar>
  )
}

export default AbsencesToolbarDesktop
